import { useEffect, useState } from 'react';
import { SellerHomePage } from './seller/SellerHomePage';
import { DesktopSellerHomePage } from './desktop/DesktopSellerHomePage';

export function ResponsiveSellerHomePage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // 초기 확인
    checkScreenSize();

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener('resize', checkScreenSize);

    // 클린업
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  // 화면 크기에 따라 모바일 또는 데스크톱 컴포넌트 렌더링
  return isMobile ? <SellerHomePage /> : <DesktopSellerHomePage />;
}